module.exports = __webpack_public_path__ + "img/ico_quick_chatbot.f03ee3c.png";